import React from 'react';
import PropTypes from 'prop-types';
import I18N from './I18N';

const Loading = ({ type }) => {
  const LoadingContent = (
    <div className="d-flex justify-content-center align-items-center">
      <div className="loading-backdrop" />
      <div className="loading-gif">
        <I18N>ssp.request.working</I18N>
      </div>
    </div>
  );

  return (
    <>
      {type === 'ajax' && (
        <>
          <div
            id="sspAjaxLoadingSubscriptions"
            className="ajax-loading-box"
            style={{ display: 'none' }}
          >
            {LoadingContent}
          </div>
          <div id="sspAjaxLoading" className="ajax-loading-box" style={{ display: 'none' }}>
            {LoadingContent}
          </div>
        </>
      )}
      {type !== 'ajax' && (
        <div className="loading-box">
          <div className="loading">&nbsp;</div>
        </div>
      )}
    </>
  );
};


Loading.propTypes = {
  type: PropTypes.string,
};

Loading.defaultProps = {
  type: '',
};

export default Loading;
